import { CAMPOS_DO_PROTHEUS, type EntidadeRotina } from '@triade/contracts';
import { Badge } from '@/components/ui/badge';

/** Texto do selo e do aviso de campo travado (tooltip e aria-label). */
export const TEXTO_DO_PROTHEUS = 'Dado do Protheus: editar no Protheus';
/** `title` dos campos somente leitura por vir do Protheus. */
export const TITULO_CAMPO_PROTHEUS = 'Editar no Protheus';

/** Selo pequeno "Protheus": marca o registro (ou o campo) que vem de uma rotina de importacao. */
export function SeloProtheus() {
  return (
    <Badge variant="outline" title={TEXTO_DO_PROTHEUS} aria-label={TEXTO_DO_PROTHEUS} className="border-primary/30 text-primary">
      Protheus
    </Badge>
  );
}

/** Campo vem do Protheus (somente leitura na tela): o registro e `doProtheus` e o campo esta em `CAMPOS_DO_PROTHEUS` da entidade. */
export function campoDoProtheus(entidade: EntidadeRotina, doProtheus: boolean | undefined, campo: string): boolean {
  return doProtheus === true && CAMPOS_DO_PROTHEUS[entidade].includes(campo);
}

/** Conjunto de campos travados para o sub-formulario de parceiro (undefined quando nao e do Protheus: nada muda). */
export function camposDoProtheusDe(entidade: EntidadeRotina, doProtheus: boolean | undefined): ReadonlySet<string> | undefined {
  return doProtheus === true ? new Set(CAMPOS_DO_PROTHEUS[entidade]) : undefined;
}
